"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelTransformService = void 0;
const TransformControls_1 = require("three/examples/jsm/controls/TransformControls");
const three_1 = require("three");
const pubsub_js_1 = require("pubsub-js");
//TODO: rename to ObjectTransformService
class ModelTransformService {
    constructor(webgl) {
        this.coordinateSpace = "world" /* WORLD */;
        this.objectsInitialState = {};
        this.objectsPreviousState = {};
        //TODO: do this better
        this.isModel = false;
        // private boxHelper?: BoxHelper;
        this._hasControlsAttached = false;
        this.transformation = {
            position: new three_1.Vector3(),
            rotation: new three_1.Euler(),
            scale: new three_1.Vector3()
        };
        this.flipped = false;
        this.modelTransformFunctions = {
            mouseDown: () => this.onMouseDown(),
            mouseUp: () => this.onMouseUp(),
            change: () => this.onChange(),
        };
        this.webgl = webgl;
    }
    get hasControlsAttached() { return this._hasControlsAttached; }
    set hasControlsAttached(isAttached) { this._hasControlsAttached = isAttached; }
    get areControlsVisible() {
        var _a;
        return ((_a = this.transformControls) === null || _a === void 0 ? void 0 : _a.visible) || false;
    }
    /**
     * Create transform controls
     */
    createControls() {
        this.transformControls = new TransformControls_1.TransformControls(this.webgl.camera, this.webgl.renderer.domElement);
        this.createControlEvents();
        this.webgl.addObject(this.transformControls);
        this.hasControlsAttached = true;
    }
    /**
     * Remove transform controls
     */
    removeControls() {
        this.clear();
        this.hasControlsAttached = false;
    }
    clear() {
        if (!this.transformControls) {
            return;
        }
        this.detachObject();
        this.removeControlEvents();
        this.transformControls.dispose();
        this.webgl.removeObject(this.transformControls);
    }
    hideControls() {
        if (!this.transformControls) {
            return;
        }
        this.transformControls.visible = false;
        this.webgl.renderOnce();
    }
    showControls() {
        if (!this.transformControls) {
            return;
        }
        this.transformControls.visible = true;
        this.webgl.renderOnce();
    }
    /**
     * Attach object to transform control
     * @param object
     */
    attachObject(object) {
        if (!this.transformControls) {
            throw new Error('Transform controls are undefined');
        }
        this.transformControls.detach();
        if (object !== null && object.parent !== null) {
            this.transformControls.attach(object);
        }
        this.transformation.position.copy(this.transformControls.position);
        this.transformation.rotation.copy(this.transformControls.rotation);
        this.transformation.scale.copy(this.transformControls.scale);
        if (!this.objectsInitialState[object.id]) {
            this.objectsInitialState[object.id] = {
                position: new three_1.Vector3(),
                rotation: new three_1.Euler(),
                scale: new three_1.Vector3()
            };
            this.objectsInitialState[object.id].position.set(object.position.x, object.position.y, object.position.z);
            this.objectsInitialState[object.id].rotation.set(object.rotation.x, object.rotation.y, object.rotation.z);
            this.objectsInitialState[object.id].scale.set(object.scale.x, object.scale.y, object.scale.z);
        }
        //Chech if model is selected
        if (object.type == 'Mesh') {
            this.isModel = true;
        }
        this.webgl.renderOnce();
    }
    /**
     * Detach object from transform control
    */
    detachObject() {
        var _a, _b;
        this.isModel = false;
        (_a = this.transformControls) === null || _a === void 0 ? void 0 : _a.detach();
        (_b = this.transformControls) === null || _b === void 0 ? void 0 : _b.setSpace('world');
        this.webgl.renderOnce();
    }
    createControlEvents() {
        if (!this.transformControls) {
            throw new Error("Transform controls are undefined");
        }
        this.transformControls.addEventListener('mouseDown', this.modelTransformFunctions.mouseDown);
        this.transformControls.addEventListener('mouseUp', this.modelTransformFunctions.mouseUp);
        this.transformControls.addEventListener('change', this.modelTransformFunctions.change);
    }
    removeControlEvents() {
        var _a, _b, _c;
        (_a = this.transformControls) === null || _a === void 0 ? void 0 : _a.removeEventListener('mouseDown', this.modelTransformFunctions.mouseDown);
        (_b = this.transformControls) === null || _b === void 0 ? void 0 : _b.removeEventListener('mouseUp', this.modelTransformFunctions.mouseUp);
        (_c = this.transformControls) === null || _c === void 0 ? void 0 : _c.removeEventListener('change', this.modelTransformFunctions.change);
    }
    changeModeTo(modelTransformType) {
        var _a;
        (_a = this.transformControls) === null || _a === void 0 ? void 0 : _a.setMode(modelTransformType);
    }
    toggleSpace() {
        var _a;
        this.coordinateSpace = this.coordinateSpace === "world" /* WORLD */ ? "local" /* LOCAL */ : "world" /* WORLD */;
        (_a = this.transformControls) === null || _a === void 0 ? void 0 : _a.setSpace(this.coordinateSpace);
    }
    resetChanges() {
        var _a, _b, _c, _d, _e, _f;
        if (!this.webgl.selected) {
            return;
        }
        if (!this.objectsInitialState[this.webgl.selected.id]) {
            return;
        }
        this.transformation.position.copy(this.objectsInitialState[this.webgl.selected.id].position);
        this.transformation.rotation.copy(this.objectsInitialState[this.webgl.selected.id].rotation);
        this.transformation.scale.copy(this.objectsInitialState[this.webgl.selected.id].scale);
        (_b = (_a = this.transformControls) === null || _a === void 0 ? void 0 : _a.object) === null || _b === void 0 ? void 0 : _b.position.copy(this.objectsInitialState[this.webgl.selected.id].position);
        (_d = (_c = this.transformControls) === null || _c === void 0 ? void 0 : _c.object) === null || _d === void 0 ? void 0 : _d.rotation.copy(this.objectsInitialState[this.webgl.selected.id].rotation);
        (_f = (_e = this.transformControls) === null || _e === void 0 ? void 0 : _e.object) === null || _f === void 0 ? void 0 : _f.scale.copy(this.objectsInitialState[this.webgl.selected.id].scale);
        this.updateAnnotationPosition();
        this.webgl.renderOnce();
        PubSub.publish("model-transform-change" /* MODEL_TRANSFORM_CHANGE */, this.transformation);
    }
    resetObjectValues() {
        this.objectsInitialState = {};
        if (this.webgl.selected) {
            this.detachObject();
            this.attachObject(this.webgl.selected);
        }
    }
    flipYZ() {
        var _a, _b, _c;
        if (!this.webgl.selected) {
            return;
        }
        let x = this.flipped ? this.webgl.selected.rotation.x + (90 * three_1.MathUtils.DEG2RAD) : this.webgl.selected.rotation.x - (90 * three_1.MathUtils.DEG2RAD);
        let y = this.webgl.selected.rotation.y;
        let z = this.flipped ? this.webgl.selected.rotation.z - (180 * three_1.MathUtils.DEG2RAD) : this.webgl.selected.rotation.z + (180 * three_1.MathUtils.DEG2RAD);
        const flippedRotation = new three_1.Euler(x, y, z);
        (_b = (_a = this.transformControls) === null || _a === void 0 ? void 0 : _a.object) === null || _b === void 0 ? void 0 : _b.rotation.copy(flippedRotation);
        this.transformation.rotation.copy(flippedRotation);
        (_c = this.webgl.selected) === null || _c === void 0 ? void 0 : _c.rotation.copy(flippedRotation);
        this.webgl.renderOnce();
        PubSub.publish("model-transform-change" /* MODEL_TRANSFORM_CHANGE */, this.transformation);
        this.flipped = !this.flipped;
    }
    onMouseDown() {
        var _a;
        const object = (_a = this.transformControls) === null || _a === void 0 ? void 0 : _a.object;
        if (object !== undefined) {
            this.objectPositionOnDown = object.position.clone();
            this.objectRotationOnDown = object.rotation.clone();
            this.objectScaleOnDown = object.scale.clone();
        }
        this.webgl.orbitControls.enabled = false;
    }
    onMouseUp() {
        var _a, _b;
        const object = (_a = this.transformControls) === null || _a === void 0 ? void 0 : _a.object;
        if (object !== undefined) {
            switch ((_b = this.transformControls) === null || _b === void 0 ? void 0 : _b.getMode()) {
                case "translate" /* TRANSLATE */:
                    if (this.objectPositionOnDown && !this.objectPositionOnDown.equals(object.position)) {
                        this.transformation.position.copy(object.position);
                    }
                    break;
                case "rotate" /* ROTATE */:
                    if (this.objectRotationOnDown && !this.objectRotationOnDown.equals(object.rotation)) {
                        this.transformation.rotation.copy(object.rotation);
                    }
                    break;
                case "scale" /* SCALE */:
                    if (this.objectScaleOnDown && !this.objectScaleOnDown.equals(object.scale)) {
                        this.transformation.scale.copy(object.scale);
                    }
                    break;
            }
            PubSub.publish("model-transform-change" /* MODEL_TRANSFORM_CHANGE */, object);
        }
        this.webgl.orbitControls.enabled = true;
    }
    onChange() {
        this.updateAnnotationPosition();
        this.webgl.renderOnce();
    }
    updateAnnotationPosition() {
        var _a, _b, _c, _d;
        if (((_b = (_a = this.webgl) === null || _a === void 0 ? void 0 : _a.selected) === null || _b === void 0 ? void 0 : _b.id) != undefined && ((_c = this.transformControls) === null || _c === void 0 ? void 0 : _c.object) != undefined && this.isModel) {
            const object = (_d = this.transformControls) === null || _d === void 0 ? void 0 : _d.object;
            const objectTransform = {
                position: new three_1.Vector3(object.position.x, object.position.y, object.position.z),
                rotation: new three_1.Euler().copy(object.rotation),
                scale: this.transformation.scale
            };
            if (this.objectsPreviousState[this.webgl.selected.id] == undefined) {
                this.objectsPreviousState[this.webgl.selected.id] = this.objectsInitialState[this.webgl.selected.id];
            }
            const deltaTranformation = {
                position: new three_1.Vector3(objectTransform.position.x - this.objectsPreviousState[this.webgl.selected.id].position.x, objectTransform.position.y - this.objectsPreviousState[this.webgl.selected.id].position.y, objectTransform.position.z - this.objectsPreviousState[this.webgl.selected.id].position.z),
                rotation: new three_1.Euler().copy(this.objectsPreviousState[this.webgl.selected.id].rotation),
                scale: this.transformation.scale
            };
            this.objectsPreviousState[this.webgl.selected.id] = {
                position: new three_1.Vector3(objectTransform.position.x, objectTransform.position.y, objectTransform.position.z),
                rotation: new three_1.Euler().copy(objectTransform.rotation),
                scale: objectTransform.scale
            };
            (0, pubsub_js_1.publish)("update annotation position in space" /* UPDATE_ANNOTATION_POSITION_IN_SPACE */, { current: objectTransform, initial: this.objectsInitialState[this.webgl.selected.id], delta: deltaTranformation });
        }
    }
}
exports.ModelTransformService = ModelTransformService;
